import React from 'react';
import Accent from '@/components/typography/Accent';
import Paragraph from '@/components/typography/Paragraph';

const Design = () => (
  <>
    <Paragraph>
      Having studied Marketing and project management, I am aware of the
      strategic implications of web applications. How they have to meet a
      specific target with specific requirements and need to provide an engaging
      level of <Accent>interactivity for the end user</Accent>.
    </Paragraph>
    <Paragraph>
      I have been involved (and still is) in UX strategies, user testing,
      <Accent> prototyping and design process</Accent>. All companies don&apos;t
      have the luxury of having a dedicated UX designer on board and even though
      I don&apos;t pretend to be a designer myslef I have been able to bridge
      the gap between development and design on diverse occasions using
      Photoshop and Sketch.
    </Paragraph>
  </>
);

Design.propTypes = {};

export default Design;
